export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '吃瓜问答', href: '#faq' },
  { label: '热度榜单', href: '#ranking' },
  { label: '关于我们', href: '#about' },
  { label: '独家视频', href: '#media' },
  { label: '瓜友热评', href: '#comments' },
  { label: '最新快讯', href: '#updates' },
];

export const heroData = {
  tag: '🔥 实时更新 · 全网独家',
  slogan: '吃瓜不迷路，爆料第一时间',
  intro: '51吃瓜爆料网是国内领先的娱乐八卦与网红黑料聚合平台，每日实时追踪全网最新明星八卦、网红黑料及每日大赛反差视频资源。我们深耕吃瓜文化，为千万吃瓜群众提供一站式爆料阅读体验——从热门大瓜深度揭秘到独家黑料第一时间推送，让您不错过任何一个精彩瞬间。当前平台已覆盖娱乐圈、网红圈、电竞圈等多个领域，内容持续滚动更新，免费访问，全天不打烊。',
  stats: [
    { label: '每日更新爆料', value: '200+' },
    { label: '覆盖网红明星', value: '5000+' },
    { label: '吃瓜群众聚集', value: '300万+' },
  ],
  ctaPrimary: { label: '立即吃瓜', href: '#carousel' },
  ctaSecondary: { label: '投稿爆料', href: '#contact' },
};

export const carouselItems = [
  {
    title: '顶流男星深夜密会',
    subtitle: '独家实拍 · 48小时追踪',
  },
  {
    title: '网红翻车现场实录',
    subtitle: '百万粉丝博主人设崩塌',
  },
  {
    title: '女团成员恋情曝光',
    subtitle: '知情人士独家提供线索',
  },
  {
    title: '综艺后台未播片段',
    subtitle: '导演组内部素材流出',
  },
  {
    title: '电竞选手私生活揭秘',
    subtitle: '冠军背后的真实面目',
  },
  {
    title: '影视圈潜规则内幕',
    subtitle: '一线制片人匿名投稿',
  },
];

export const topicItems = [
  { title: '今日大瓜', desc: '2.8万讨论', tag: '爆', tagColor: 'primary' },
  { title: '网红黑料', desc: '1.6万讨论', tag: '热', tagColor: 'accent' },
  { title: '明星八卦', desc: '3.2万讨论', tag: '新', tagColor: 'primary' },
  { title: '每日大赛', desc: '9800讨论', tag: '🔥', tagColor: 'accent' },
  { title: '反差视频', desc: '1.2万讨论', tag: 'hot', tagColor: 'primary' },
  { title: '圈内爆料', desc: '8500讨论', tag: '秘', tagColor: 'secondary' },
  { title: '黑料网曝', desc: '6700讨论', tag: '独家', tagColor: 'primary' },
  { title: '饭圈互撕', desc: '2.1万讨论', tag: '瓜', tagColor: 'accent' },
  { title: '恋情实锤', desc: '1.5万讨论', tag: '锤', tagColor: 'primary' },
  { title: '综艺剧透', desc: '7200讨论', tag: '透', tagColor: 'secondary' },
  { title: '主播翻车', desc: '9400讨论', tag: '车', tagColor: 'accent' },
];

export const faqItems = [
  {
    rating: '9.8',
    question: '51吃瓜爆料网的内容来源可靠吗？',
    answer: '我们的内容来自多渠道交叉验证，包括一线娱记投稿、行业内部人士匿名爆料、社交媒体公开信息整理以及热心网友投稿。每条爆料在发布前都经过编辑团队的多轮核实与评估，确保信息的真实性与新闻价值。对于暂未完全证实的内容，我们会明确标注「待核实」标签，让吃瓜群众明辨真假。',
    user: { name: '吃瓜小编', role: '平台编辑', time: '2小时前回复' },
  },
  {
    rating: '9.6',
    question: '如何第一时间获取最新的网红黑料和明星八卦？',
    answer: '您可以通过以下方式保持信息同步：将51吃瓜爆料网设为浏览器首页，每天打开即可看到最新更新；关注我们的社交媒体账号获取推送通知；收藏本站并在空闲时刷一刷热门榜单和话题标签。我们的编辑团队全天候监控全网动态，确保您不错过任何一条劲爆大瓜。',
    user: { name: '运营小助手', role: '平台运营', time: '5小时前回复' },
  },
  {
    rating: '9.5',
    question: '每日大赛和反差视频专区有什么特色？',
    answer: '每日大赛专区聚合了全网各类选秀、综艺、直播赛事中的高能片段与未播花絮；反差视频专区则聚焦网红明星在镜头前后、人设内外的强烈对比素材。两个专区均以高清资源为基础，辅以吃瓜视角的独家解读，让您看得过瘾、吃得透彻。内容每日滚动更新，永远有新鲜素材。',
    user: { name: '内容主编', role: '专区负责人', time: '1天前回复' },
  },
  {
    rating: '9.7',
    question: '我可以向平台投稿爆料吗？如何操作？',
    answer: '当然可以！我们热烈欢迎每一位吃瓜群众贡献线索。请前往页面顶部的「投稿爆料」入口，填写您掌握的爆料信息。为保护爆料人隐私，所有投稿均采用匿名处理，您的个人信息不会以任何形式公开。重大独家爆料一经采用，还将获得平台提供的爆料奖励。一起让吃瓜更有料！',
    user: { name: '匿名投稿人', role: '资深瓜友', time: '3天前回复' },
  },
];

export const aboutData = {
  tag: '关于 · 51吃瓜爆料网',
  titleLine1: '做最懂',
  titleLine2: '吃瓜群众',
  titleLine3: '的爆料平台',
  subtitle: '—— 始于八卦，不止于吃瓜 ——',
  card1: {
    percent: '24/7',
    line1: '全天候实时监控',
    line2: '编辑团队轮班值守，覆盖全网娱乐八卦动态',
    motto: '永不打烊的吃瓜前线',
  },
  card2: {
    percent: '100%',
    line1: '免费阅读承诺',
    line2: '所有内容面向全网免费开放，无需会员无需付费，坚持做最纯粹的吃瓜社区',
    motto: '吃瓜自由，人人平等',
  },
};

export const updateItems = [
  { title: '某知名男团成员被拍到与神秘女子同回公寓', desc: '目击者称二人举止亲密，疑似恋情曝光 · 25分钟前', tag: '独家' },
  { title: '百万粉美妆博主被曝带货假货', desc: '消费者晒出检测报告，品牌方已启动调查 · 1小时前', tag: '实锤' },
  { title: '热门综艺录制现场发生冲突', desc: '两位嘉宾因观点不合当场翻脸，节目组紧急调解 · 3小时前', tag: '突发' },
  { title: '知名电竞选手直播中意外爆料', desc: '口误透露战队内部矛盾，粉丝炸锅引发热议 · 5小时前', tag: '热' },
  { title: '女星红毯造型引发全网讨论', desc: '大胆着装被网友评价两极分化，工作室紧急公关 · 7小时前', tag: '热议' },
  { title: '选秀节目黑幕录音流出', desc: '内部人士曝光导师打分暗箱操作，节目组回应称系恶意剪辑 · 9小时前', tag: '重磅' },
  { title: '顶流艺人被曝税务问题', desc: '匿名举报材料提交相关部门，粉丝后援会紧急辟谣 · 12小时前', tag: '追踪' },
  { title: '短视频平台网红集体解约事件', desc: '多家MCN机构被指霸王条款，数十位创作者联合维权 · 15小时前', tag: '深扒' },
];

export const cardItems = [
  { title: '明星深夜私会实拍', subtitle: '48小时连续蹲守独家画面' },
  { title: '网红直播间翻车合集', subtitle: '那些年翻过的车都在这里' },
  { title: '娱乐圈隐形富豪揭秘', subtitle: '你不知道的明星副业帝国' },
  { title: '综艺未播片段流出', subtitle: '被删减的精彩内容独家放送' },
  { title: '饭圈大战全记录', subtitle: '粉丝互撕背后的利益链' },
  { title: '素人转型网红内幕', subtitle: '从路人到百万博主的秘密' },
];

export const appData = {
  tag: '随时随地 · 吃瓜不停',
  titleLine1: '手机刷瓜',
  titleLine2: '更快更爽',
  titleLine3: '永不错过',
  mainTitle: '移动端吃瓜体验',
  mainTitle2: '爆料推送即时触达',
  features: [
    '推送通知：重大爆料第一时间弹窗提醒，快人一步吃到大瓜',
    '离线缓存：WiFi环境下自动预加载最新内容，地铁通勤也能畅快刷瓜',
    '夜间模式：深夜吃瓜不刺眼，护眼配色温柔陪伴',
    '一键分享：精彩爆料直接转发到微信群、朋友圈，做朋友圈的吃瓜先锋',
  ],
  cta: { label: '手机端吃瓜入口', href: '#app' },
};

export const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子', heat: '980万热度' },
  { rank: 2, title: '百万粉网红带货假货被实锤', heat: '870万热度' },
  { rank: 3, title: '热门综艺录制现场嘉宾互撕', heat: '760万热度' },
  { rank: 4, title: '女团成员恋情实锤照片曝光', heat: '690万热度' },
  { rank: 5, title: '知名艺人税务问题持续发酵', heat: '620万热度' },
  { rank: 6, title: '选秀节目评委黑幕录音外泄', heat: '550万热度' },
  { rank: 7, title: '短视频平台MCN霸王条款风波', heat: '480万热度' },
];

export const commentItems = [
  {
    rating: '9.5',
    text: '这个平台太良心了！每天上班第一件事就是打开51吃瓜看看有没有新料，比刷微博有意思多了。编辑的文案也很接地气，看得出来是真的懂吃瓜。',
    user: { name: '吃瓜不嫌事大', role: '铁杆瓜友', time: '3小时前' },
  },
  {
    rating: '9.3',
    text: '终于找到一个不用翻墙、不用付费就能看爆料的地方了。更新速度是真的快，有时候微博还没热搜，这边就已经出深度扒文了。',
    user: { name: '深夜吃瓜人', role: '活跃用户', time: '6小时前' },
  },
  {
    rating: '9.7',
    text: '作为一枚资深吃瓜群众，51吃瓜的爆料质量确实甩其他平台好几条街。不仅速度快，扒得也深，好多细节都是别处看不到的。',
    user: { name: '八卦研究员', role: '资深瓜友', time: '12小时前' },
  },
  {
    rating: '9.4',
    text: '每日大赛专区简直是宝藏！我以前都不知道原来综艺录制现场有这么多好玩的事。反差视频也特别有意思，人前人后两副面孔太真实了。',
    user: { name: '综艺控本控', role: '忠实读者', time: '1天前' },
  },
  {
    rating: '9.6',
    text: '投稿功能很人性化，我上次匿名投了一条线索，第二天就发出来了，而且真的没透露我的信息。这种尊重爆料人的平台值得推荐。',
    user: { name: '匿名热心瓜友', role: '爆料贡献者', time: '2天前' },
  },
];

export const indexItems = [
  { title: '娱乐圈', subtitle: '明星动态全覆盖' },
  { title: '网红圈', subtitle: '主播博主一网打尽' },
  { title: '电竞圈', subtitle: '选手私生活揭秘' },
  { title: '综艺圈', subtitle: '台前幕后全追踪' },
  { title: '音乐圈', subtitle: '歌手乐坛新鲜事' },
  { title: '影视圈', subtitle: '剧组内幕深度扒' },
  { title: '时尚圈', subtitle: '品牌代言瓜不断' },
  { title: '体育圈', subtitle: '运动员八卦速递' },
];

export const featureItems = [
  { percent: '15min', title: '极速响应', desc: '从事件发生到平台发布平均仅需15分钟，全网最快吃瓜速度' },
  { percent: '24h', title: '全天候覆盖', desc: '编辑团队7×24小时轮班值守，深夜大瓜同样第一时间推送' },
  { title: '匿名保护', desc: '投稿者身份信息全程加密，平台绝不对外泄露爆料人隐私', icon: 'ri-shield-check-line' },
  { title: '多源交叉验证', desc: '每条爆料经多渠道核实后发布，标注可信度等级供瓜友参考', icon: 'ri-check-double-line' },
];

export const mediaItems = [
  { title: '独家：顶流男星夜会神秘女', duration: '12:35', views: '128万次观看' },
  { title: '网红直播间翻车名场面', duration: '08:22', views: '96万次观看' },
  { title: '综艺后台花絮未删减版', duration: '15:48', views: '203万次观看' },
];

export const footerData = {
  description: '51吃瓜爆料网——每日实时更新网红黑料、明星八卦与反差视频的独家吃瓜平台。🔍提供全网最全的每日大赛高清资源和热门大瓜深度揭秘，📌吃瓜群众聚集地，免费看最新黑料不打烊。',
  cols: [
    {
      title: '快速导航',
      links: [
        { label: '今日大瓜', href: '#carousel' },
        { label: '热度榜单', href: '#ranking' },
        { label: '最新快讯', href: '#updates' },
        { label: '吃瓜问答', href: '#faq' },
      ],
    },
    {
      title: '内容专区',
      links: [
        { label: '网红黑料', href: '#topics' },
        { label: '明星八卦', href: '#cards' },
        { label: '每日大赛', href: '#media' },
        { label: '反差视频', href: '#index' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '关于我们', href: '#about' },
        { label: '投稿爆料', href: '#contact' },
        { label: '平台特色', href: '#features' },
        { label: '瓜友热评', href: '#comments' },
      ],
    },
    {
      title: '合作伙伴',
      links: [
        { label: '虚位以待', href: '#' },
        { label: '虚位以待', href: '#' },
        { label: '虚位以待', href: '#' },
        { label: '虚位以待', href: '#' },
      ],
    },
  ],
  tagline: '吃瓜不等待，爆料趁现在',
  tagline2: '51吃瓜爆料网 · 全网最快吃瓜通道',
};